import { createAction, props } from '@ngrx/store';

export const saveReservation = createAction(
    '[AUTH] save reservation',
    props<{ value: any }>(),
);

export const updateReservation = createAction(
    '[AUTH] update reservation',
    props<{ value: any }>(),
);

export const getReservation = createAction(
    '[AUTH] get reservation',
    props<{ value: any }>(),
);

export const clearReservation = createAction('[AUTH] clear reservation');
